import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pricing-table-1',
  templateUrl: './pricing-table-1.component.html',
})
export class PricingTable1Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
